import { TableOutlined } from '@ant-design/icons';
import { type IWidgetType } from '../../../IWidgetType.ts';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget.ts';
import { createTableSchema } from './createTableSchema.ts';
import { getTableInputVirtualColumnsReferences } from './expression/getTableInputVirtualColumnsReferences.ts';
import { materializeTableInputWidgets } from './expression/materializeTableInputWidget.ts';
import { type ITableInputWidget } from './ITableInputWidget.ts';
import { TableInputConfigSchema } from './TableInputWidget.validator.ts';
import { TableInputWidgetComponent } from './TableInputWidgetComponent.tsx';
import { TableInputWidgetConfigComponent } from './TableInputWidgetConfigComponent.tsx';
import { TableInputWidgetPreview } from './TableInputWidgetPreview.tsx';
import { TableInputWidgetTranslationSchema } from './TableInputWidgetTranslationSchema.ts';

/**
 * Tipo del componente Tabella contenitore di campi di Input.
 */
export const TableInputWidgetType: IWidgetType<ITableInputWidget> = {
  type: WidgetType.TableInput,
  mainType: WidgetMainType.Base,
  category: WidgetCategory.Advanced,
  name: 'Tabella di Input',
  icon: <TableOutlined />,
  hasValue: false,
  // getReference: getTableInputWidgetReference,
  materializeChildren: materializeTableInputWidgets,
  getParentVirtualReferences: getTableInputVirtualColumnsReferences,
  formComponent: TableInputWidgetComponent,
  createFormSchema: createTableSchema,
  configComponent: TableInputWidgetConfigComponent,
  configValidator: TableInputConfigSchema,
  previewComponent: TableInputWidgetPreview,
  translationSchema: TableInputWidgetTranslationSchema,
  rules: [],
};
